import { render, staticRenderFns } from "./mediaDetail.vue?vue&type=template&id=c68db3fc&scoped=true&"
import script from "./mediaDetail.vue?vue&type=script&lang=js&"
export * from "./mediaDetail.vue?vue&type=script&lang=js&"
import style0 from "./mediaDetail.vue?vue&type=style&index=0&id=c68db3fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c68db3fc",
  null
  
)

export default component.exports